import React from 'react'
import PropTypes from 'prop-types'

import { LoadingSpinner } from '../../components'

const Statistic = props => {
  const { title, color, textColor, iconClass, link } = props

  let value = props.value

  if (props.loading) {
    value = <LoadingSpinner />
  } else if (props.error) {
    value = 'Error'
  }

  return (
    <a
      href={link}
      className="statistic font-title"
      style={{ backgroundColor: color, color: textColor }}
    >
      <span className={`${iconClass} pull-left`} />
      {value}
      <div className="title">{title}</div>
    </a>
  )
}

Statistic.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
}

export default Statistic
